import extendsApi from 'services/extendsApi'

class StoreServiceApi extends extendsApi {
  constructor () {
    super()
    this.userStatusUrl = '/20180815/prophet/userStatus'
  }
  get (type, params, baseUrl) {
    return this.sendGet(this[`${type}Url`], params, baseUrl).then(res => {
      return res.data
    })
  }
  post (type, params, baseUrl) {
    return this.sendPost(this[`${type}Url`], params, baseUrl).then(res => {
      return res.data
    })
  }
}

export default new StoreServiceApi()



// WEBPACK FOOTER //
// ./src/store/storeService.js